'use client';
var optionsOptionsRegistry = {
    json: true,
    parseJson: true,
    searchParams: true,
    prefixUrl: true,
    timeout: true,
    middlewares: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    fetch: true
};
var requestOptionsRegistry = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    dispatcher: true,
    duplex: true,
    // @ts-expect-error - Устаревшие типы.
    priority: true
};
/**
 * Выбирает только те опции, которые не участвуют в конфигурировании
 * Client и не присутствуют в request.
 * */ var getUnknownOptions = function(request, options) {
    var unknownOptions = {};
    for(var key in options){
        if (!(key in requestOptionsRegistry) && !(key in optionsOptionsRegistry) && !(key in request)) {
            unknownOptions[key] = options[key];
        }
    }
    return unknownOptions;
};

export { getUnknownOptions };
